<script>
export default {
  name: 'MinitChat',
  props: {
    event: {
      type: Object,
      required: true,
      fields: {
        chat: {
          organizationId: String,
          chatName: String,
          ssoToken: String,
        },
      },
    },
  },
  computed: {
    iframeSrc() {
      // eslint-disable-next-line max-len
      return `https://organizations.minnit.chat/${this.organization}/c/${this.name}?embed&ssotoken=${this.sso}`;
    },
    organization() {
      return this.event?.chat?.organizationId;
    },
    name() {
      return this.event?.chat?.chatName;
    },
    sso() {
      return this.event?.chat?.ssoToken;
    },
  },
};
</script>

<template>
    <iframe :src="iframeSrc"
            style="border:none;
            width:90%;
            height:100%;
            max-height:90vh;
            min-height: 25rem"
            allowTransparency="true"
    />
</template>

